/**
 * NoticeListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  ModalLayout,
  InputFormTable,
  HtmlContent,
} from 'components';
import { Button, DatePicker, Input, Radio, Switch } from 'antd';
import moment from 'moment';
import { DeleteOutlined } from '@ant-design/icons';

const NoticeListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isOpened, setIsOpened] = useState(false);
  const [modalType, setModalType] = useState('CREATE');

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '구분',
      form: [
        {
          input: (
            <Radio.Group value={'전체'}>
              <Radio value={'전체'}>전체</Radio>
              <Radio value={'상위노출'}>상위노출</Radio>
              <Radio value={'일반'}>일반</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '날짜',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '검색어',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 400 }}
              />
            </>
          ),
        },
      ],
    },
  ];

  const form = [
    {
      label: '제목',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="새 게시글의 제목을 입력해주세요"
              style={{ ...styles.form.input.large, width: 400 }}
            />
          ),
          count: true,
          maxLength: 50,
        },
      ],
    },
    {
      label: '내용',
      form: [
        {
          input: <div style={{ height: 430 }}>에디터!!!!</div>,
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 10; i++) {
    newData.push({
      구분:
        i < 3 ? (
          <span
            style={{
              border: '1px solid #FF881A',
              color: '#FF881A',
              borderRadius: 2,
              padding: '1px 11px',
            }}
          >
            상위노출
          </span>
        ) : (
          '일반'
        ),
      title:
        '새로운 공지사항이 게시되었습니다. 확인 후 적용바랍니다. 어쩌고 저쩌고 이렇고 저렇고 깔깔',
      created_at: new Date(),
      updated_at: new Date(),
      is_show: <Switch size="large" />,
    });
  }

  /* ===== FUNCTION ===== */
  /**
   * 모달 핸들러
   * --
   */
  const handleOpenModal = (t = 'CREATE', d) => {
    const type = t.toLocaleUpperCase();
    setModalType(type);
    console.log('data', d);

    switch (type) {
      case 'CREATE':
        break;
      case 'UPDATE':
        break;
      case 'DETAIL':
        break;
      default:
        break;
    }

    setIsOpened(!isOpened);
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>공지사항 관리</Title>

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40 }}
            >
              <ExpandableContainer borderRadius={4} padding={20}>
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 20,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                >
                  검색
                </Button>
                <Button size="large" style={{ ...styles.button }}>
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}
            </Content>
            {/* 검색필터 끝 */}

            {/* 검색결과 */}
            <Content maxWidth={'100%'} borderRadius={4} padding={20}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                  총 <span>0</span>개
                </h4>
                <Button
                  size="large"
                  style={{ marginRight: 8 }}
                  onClick={() => handleOpenModal('create')}
                >
                  새 게시글
                </Button>
                <Button
                  size="large"
                  style={{ marginRight: 8 }}
                  icon={<DeleteOutlined />}
                  danger
                >
                  선택 삭제
                </Button>
              </div>
              <Table
                data={newData}
                isChecked
                onRow={(item) => {
                  handleOpenModal('detail', item);
                }}
                columns={[
                  {
                    title: '구분',
                    key: '구분',
                  },
                  {
                    title: '제목',
                    key: 'title',
                    width: 500,
                  },
                  {
                    title: '등록일',
                    key: 'created_at',
                    render: (item) => moment(item).format('YYYY-MM-DD'),
                  },
                  {
                    title: '수정일',
                    key: 'updated_at',
                    render: (item) => moment(item).format('YYYY-MM-DD'),
                  },
                  {
                    title: '노출여부',
                    key: 'is_show',
                  },
                ]}
              />
            </Content>
            {/* 검색결과 끝 */}
          </Col>
        </Row>
      </Content>

      {/* 모달 */}
      <ModalLayout
        type={'modal'}
        open={isOpened}
        onCancel={setIsOpened}
        centered
        closable
        title={
          modalType === 'CREATE'
            ? '새 게시글'
            : modalType === 'UPDATE'
            ? '게시글 수정'
            : '게시글 상세보기'
        }
        width={798}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={8} style={{ textAlign: 'left', display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: 12,
                  }}
                >
                  <p
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      lineHeight: '133%',
                      paddingRight: 5,
                    }}
                  >
                    상위노출
                  </p>
                  <Switch style={{ width: 24 }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      lineHeight: '133%',
                      paddingRight: 5,
                    }}
                  >
                    노출여부
                  </p>
                  <Switch />
                </div>
              </Col>
              <Col x={8} style={{ textAlign: 'center' }}>
                {modalType !== 'DETAIL' && (
                  <Button style={{ ...styles.button }}>미리보기</Button>
                )}
              </Col>
              <Col x={8}>
                {modalType === 'DETAIL' ? (
                  <Button style={{ ...styles.button }}>편집</Button>
                ) : (
                  <>
                    <Button style={{ ...styles.button }}>취소</Button>
                    <Button
                      type="primary"
                      style={{
                        ...styles.button,
                        background: 'var(--primary-color)',
                      }}
                    >
                      등록
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              {modalType === 'DETAIL' ? (
                <div>
                  <div style={{ borderBottom: '1px solid #F4F4F5' }}>
                    <h4
                      style={{
                        fontSize: 23,
                        fontWeight: 400,
                        marginBottom: 10,
                      }}
                    >
                      새로운 공지사항이 등록되었습니다. 확인 후 적용해주세요.
                    </h4>
                    <div
                      style={{
                        display: 'flex',
                        fontSize: 12,
                        fontWeight: 400,
                        marginBottom: 10,
                      }}
                    >
                      <p style={{ marginRight: 16 }}>
                        작성자: <span style={{ color: '#8A8A8A' }}>관리자</span>
                      </p>
                      <p>
                        작성일:{' '}
                        <span style={{ color: '#8A8A8A' }}>
                          {new Date().toString()}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div
                    style={{ height: 500, overflow: 'auto', padding: '16px 0' }}
                  >
                    <HtmlContent content={`<div>내용입니다</div>`} />
                  </div>
                </div>
              ) : (
                <InputFormTable form={form} labelWidth={148} />
              )}
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default NoticeListPresenter;
